<template>
    
    <!-- <ion-button
        :size="size"
        :expand="expand"
        :fill="fill"
        :disabled="disabled"
        :class="[
            customClass
        ]"
        :color="color"
        class="ion-no-margin"
    >
        <slot name="content"></slot>
    </ion-button> -->
    <button
        :disabled="disabled"
        class="inline-flex items-center justify-center p-3 border border-solid rounded-lg text-sm transition h-11"
        :class="[
            color,
            secondary
                ? 'bg-white border-gray-300 text-gray-500 hover:text-primary-600 focus:outline-none active:text-gray-800 active:bg-gray-50 disabled:opacity-25 '
                : 'border-primary-500 disabled:opacity-25 text-white focus:ring-1 focus:ring-offset-1'
        ]"
    >
        <PlusIcon class="w-5 h-5 mr-2" v-if="createBtn"/>
        <ArrowDownTrayIcon class="w-5 h-5 mr-2" v-else-if="exportBtn"/>
        <ArrowUpTrayIcon class="w-5 h-5 mr-2" v-else-if="importBtn"/>
        <slot></slot>
    </button>
</template>
<script setup lang="ts">
import { PlusIcon, ArrowDownTrayIcon, ArrowUpTrayIcon } from "@heroicons/vue/24/solid";
// import { IonButton } from '@ionic/vue'
defineProps({
    type: {
        type: String,
        default: 'button'
    },
    color: {
        type: String,
        default: 'bg-primary-500'
    },
    expand: {
        type: String,
        default: null // block, full
    },
    fill: {
        type: String,
        default: 'solid' // clear, outline, solid
    },
    size: {
        type: String,
        default: 'large' // small, default, large
    },
    disabled: {
        type: Boolean,
        default: false
    },
    secondary: {
        type: Boolean,
        default: false
    },
    customClass: {
        type: String,
        default: null
    },

    createBtn: {
        type: Boolean,
        default: false
    },
    exportBtn: {
        type: Boolean,
        default: false
    },
    importBtn: {
        type: Boolean,
        default: false
    },
});
</script>